import { PropsWithChildren } from 'react'
import { Box } from '@chakra-ui/react'

const LeftColumn = ({ children }: PropsWithChildren): JSX.Element => {
  return (
    <Box flex="1 1 33.66%" maxWidth="100%">
      {children}
    </Box>
  )
}

export default LeftColumn
